import { render, staticRenderFns } from "./TagField.vue?vue&type=template&id=55e21377&scoped=true&"
import script from "./TagField.vue?vue&type=script&lang=js&"
export * from "./TagField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e21377",
  null
  
)

export default component.exports